import React from "react";
import { useTranslation } from 'react-i18next';
import CremaMontanaBeige from "../Components/quarries/CremaMontanaBeige";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import productSeoData from "../data/productSeoData.json";

function CremaMontanaBeigePage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = productSeoData[currentLang]?.cremaMontana || {
    title: currentLang === 'tr' ? 'Crema Montana Beige Mermer - MOCA Mermer' : 'Crema Montana Beige Marble - MOCA Marble',
    description: currentLang === 'tr' ? 'Crema Montana Beige mermer ürünü hakkında detaylı bilgi. MOCA Mermer kalitesi ile.' : 'Detailed information about Crema Montana Beige marble product. With MOCA Marble quality.',
    keywords: currentLang === 'tr' ? 'crema montana beige, mermer, doğal taş, moca mermer' : 'crema montana beige, marble, natural stone, moca marble'
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/cremamontanabeige"
        image={seo.image}
        structuredData={seo.structuredData}
      />
      <TopBar />
      <Spacer/>
      <CremaMontanaBeige />
    </>
  );
}

export default CremaMontanaBeigePage;
